import {
  ClientIntegration,
  ClientModel,
  ThirdParty
} from "@/interfaces/thirdParty";
import { ThirdPartyTableHeaders } from "@/metadata/thirdParty";
import thirdPartyActionService from "@/services/thirdParty.action.service";
import { thirdPartyService } from "@/services/thirdParty.service";
import {
  ActionsSubheaderComponent,
  TableAction,
  TableComponent,
  TablePagination,
  TablePaginationComponent
} from "helix-vue-components";
import { Component, Vue } from "vue-property-decorator";
import CreateClientModalComponent from "./createClientModal/createClientModal.component";
import LoadingModal from "./loadingModal/loadingModal.component";
import Template from "./ThirdParty.template.vue";

@Component({
  mixins: [Template],
  components: {
    ActionsSubheaderComponent,
    TableComponent,
    TablePaginationComponent
  }
})
export default class ThirdPartyComponent extends Vue {
  public clients: ClientIntegration[] = [];
  public loading = false;
  public pagination: TablePagination | null = null;
  public headers = ThirdPartyTableHeaders;
  public generalActions: TableAction[] = thirdPartyActionService.getGeneralActions(
    this.addClientModal
  );
  public rowActions: TableAction[] = thirdPartyActionService.getRowActions(
    this.deleteIntegration,
    this.editClient,
    this.toggleActive
  );
  public colors = ["white", "#f2f2f2", "#f2f2f2"];

  public parseScopes(thirdParty: ThirdParty) {
    return thirdParty.tokens.flatMap(token => token.scopes);
  }

  public addClientModal() {
    this.$modals
      .load(CreateClientModalComponent, {
        size: "fit",
        positionY: "top"
      })
      .then(
        async (name: unknown) => {
          const client = (await this.$modals.load(
            LoadingModal,
            {
              size: "small",
              positionX: "center",
              positionY: "center"
            },
            {
              msgModal: "client_integrations.adding_integrator",
              run: () => thirdPartyService.create({ name } as { name: string })
            }
          )) as ClientModel | null;
          if (!client) {
            return;
          }
          this.$router.push({
            name: "client-integration-edit",
            params: {
              id: String(client.id)
            },
            query: {
              showSecret: "1"
            }
          });
        },
        () => {
          // Nothing to do
        }
      );
  }

  public editClient(client: ClientIntegration) {
    this.$router.push({
      name: "client-integration-edit",
      params: {
        id: String(client.id)
      }
    });
  }

  public async getClients(pagination: TablePagination | null) {
    this.loading = true;
    const query = pagination
      ? {
          page: this.pagination!.currentPage,
          per_page: this.pagination!.itemsPerPage
        }
      : null;
    this.clients = await thirdPartyService.get(query);
    this.pagination = await thirdPartyService.getPagination();
    this.loading = false;
  }

  public async toggleActive(idx: number) {
    await thirdPartyService.toggleIntegration(
      this.clients[idx].id,
      !(this.clients[idx].status === "ENABLED")
    );
    this.clients[idx].status =
      this.clients[idx].status === "ENABLED" ? "DISABLED" : "ENABLED";
  }

  public get clientsWithIsActive() {
    if (!this.clients) {
      return [];
    }
    return this.clients.map(item => ({
      ...item,
      is_active: item.status === "ENABLED"
    }));
  }

  public async deleteIntegration(row: any) {
    await thirdPartyService.delete(row.item.id);
    this.getClients(null);
  }

  public async created() {
    this.getClients(null);
  }
}
